// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__qmMPi","fileBtn":"File_fileBtn__2hQcz","closeBtn":"File_closeBtn__1W1sE","fileSelected":"File_fileSelected__1ZtBO","disabled":"File_disabled__1qtQV"};